/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Featurestitle1Inputs */

const he_extension_featurestitle1 = /** @type {(inputs: Extension_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה לבחור ב-PriceDrop?`)
};

const en_extension_featurestitle1 = /** @type {(inputs: Extension_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why Choose PriceDrop?`)
};

/**
* | output |
* | --- |
* | "Why Choose PriceDrop?" |
*
* @param {Extension_Featurestitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_featurestitle1 = /** @type {((inputs?: Extension_Featurestitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Featurestitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_featurestitle1(inputs)
	return en_extension_featurestitle1(inputs)
});
export { extension_featurestitle1 as "extension_featuresTitle" }